import { createSlice } from "@reduxjs/toolkit";
import {
  OurReachData,
  OurReachInitialStatus,
} from "../../../../../types/webCms/homePage/ourReach";
import { getAllOurReachAsync, updateOurReachAsync } from "./ourReachApi";

const initialState: OurReachInitialStatus<OurReachData> = {
  loading: false,
  manageLoading: false,
  ourReachDataList: [],
  countOurReachData: 0,
};

const ourReachSlice = createSlice({
  name: "admin-about-sushil",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllOurReachAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllOurReachAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.ourReachDataList = action.payload.data;
        state.countOurReachData = action.payload.length;
      })
      .addCase(getAllOurReachAsync.rejected, (state) => {
        state.loading = false;
        state.ourReachDataList = [];
        state.countOurReachData = 0;
      });

    // update
    builder
      .addCase(updateOurReachAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateOurReachAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateOurReachAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default ourReachSlice;
